export default "__VITE_ASSET__DIRjR2X$__"